module.exports = __webpack_public_path__ + "media/images/city/050-roman-theater-of-merida-fbba49410f9aa4c8097d1a5639adfb71.svg";